import { Alpine as IAlpine } from 'alpinejs';
import HTMLPlayer from './HTMLPlayer';
import VimeoPlayer from './VimeoPlayer';
import YoutubePlayer from './YoutubePlayer';
import Player from './Player';

enum ALLOWED_MEDIA_TYPES {
  'mp4' = 'mp4',
  'vimeo' = 'vimeo',
  'youtube' = 'youtube',
  'webm' = 'webm'
}

const __getPlayer = function (el: HTMLElement, key: ALLOWED_MEDIA_TYPES) {
  switch (key) {
    case 'youtube':
      return new YoutubePlayer(el);
    case 'vimeo':
      return new VimeoPlayer(el);
    default:
      return new HTMLPlayer(el);
  }
};

export default function (Alpine: IAlpine) {
  // Initialize video players after DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      const videoPlayerElements = document.querySelectorAll('[x-video-player]');
      videoPlayerElements.forEach((el) => {
        if (!el.hasAttribute('data-alpine-initialized')) {
          Alpine.initTree(el as HTMLElement);
          el.setAttribute('data-alpine-initialized', 'true');
        }
      });
      
      if ((window as any).DsCookies) {
        (window as any).DsCookies.run();
      }
    }, 100);
  });

  Alpine.directive('video-player', (el, { expression }) => {
    const video = el.querySelector('.media-item');
    let player: Player;
    let playerKey: string;

    if (!video) return;
    if (!(expression in ALLOWED_MEDIA_TYPES)) return;

    playerKey = expression ? expression.toLowerCase() : '';
    player = __getPlayer(el, playerKey as ALLOWED_MEDIA_TYPES);

    el.addEventListener('videoPlayer.ready', () => {
      const playButton = el.querySelector('button:not([data-unmute-button])');
      const unmuteButton = el.querySelector('[data-unmute-button]') as HTMLButtonElement | null;
      el.addEventListener('videoPlayer.play', () => {
        player.play();
        el.classList.add('is-playing');
        el.classList.remove('is-paused');
      });
      el.addEventListener('videoPlayer.stop', () => {
        player.stop();
        el.classList.add('is-paused');
        el.classList.remove('is-playing');
      });
      if (playButton) {
        playButton.addEventListener('click', () => {
          if (el.classList.contains('is-playing')) {
            el.dispatchEvent(player.events.stop);
          } else {
            el.dispatchEvent(player.events.play);
          }
        });
      }

      // Mute / unmute toggle button for page hero YouTube videos
      if (el.closest('.ce-page-hero') && playerKey === 'youtube' && unmuteButton) {
        let isMuted = true;

        unmuteButton.addEventListener('click', () => {
          const p: any = player;
          if (isMuted) {
            p.unmute();
            isMuted = false;
            unmuteButton.classList.add('is-unmuted');
          } else {
            p.mute();
            isMuted = true;
            unmuteButton.classList.remove('is-unmuted');
          }
        });
      }
    });

    if (video.getAttribute('src') || video.querySelector('[src]')) {
      el.dispatchEvent(player.events.loadScript);
    } else {
      new MutationObserver(() => {
        el.dispatchEvent(player.events.loadScript);
      }).observe(video, {
        attributeFilter: ['src'],
      });
    }
  })
}
